import React from 'react';

const Calendar = (props) => (
	<svg
		id="ikony"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 22 22"
		{...props}
	>
		<g>
			<g>
				<rect x={13.5} y={10} width={1} height={1}/>
				<rect x={16.5} y={10} width={1} height={1}/>
				<rect x={10.5} y={10} width={1} height={1}/>
				<rect x={13.5} y={13} width={1} height={1}/>
				<rect x={16.5} y={13} width={1} height={1}/>
				<rect x={7.5} y={13} width={1} height={1}/>
				<rect x={10.5} y={13} width={1} height={1}/>
				<rect x={4.5} y={13} width={1} height={1}/>
				<rect x={13.5} y={16} width={1} height={1}/>
				<rect x={7.5} y={16} width={1} height={1}/>
				<rect x={10.5} y={16} width={1} height={1}/>
				<rect x={4.5} y={16} width={1} height={1}/>
				<path
					d="m17,4.01v-2h-1v2H6v-2h-1v2H1v16h20V4.01h-4Zm3,15H2v-11h18v11Z"
				/>
			</g>
		</g>
	</svg>
);

export default Calendar;
